/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_TaglineInputs */

const en_svc_ai_app_rescue_tagline = /** @type {(inputs: Svc_Ai_App_Rescue_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built it with Lovable, Bolt or Cursor and got stuck? I fix and ship it.`)
};

const ar_svc_ai_app_rescue_tagline = /** @type {(inputs: Svc_Ai_App_Rescue_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنيته مع Lovable أو Bolt أو Cursor وتعثرت؟ أصلحه وأطلقه.`)
};

const bn_svc_ai_app_rescue_tagline = /** @type {(inputs: Svc_Ai_App_Rescue_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lovable, Bolt বা Cursor দিয়ে বানিয়ে আটকে গেছেন? আমি ঠিক করে লঞ্চ করে দিই।`)
};

const de_svc_ai_app_rescue_tagline = /** @type {(inputs: Svc_Ai_App_Rescue_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Lovable, Bolt oder Cursor gebaut und festgefahren? Ich fixe es und bringe es live.`)
};

const es_svc_ai_app_rescue_tagline = /** @type {(inputs: Svc_Ai_App_Rescue_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿La construyó con Lovable, Bolt o Cursor y se atascó? La reparo y la lanzo.`)
};

const fr_svc_ai_app_rescue_tagline = /** @type {(inputs: Svc_Ai_App_Rescue_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construite avec Lovable, Bolt ou Cursor et bloquée ? Je la répare et la lance.`)
};

const pt_svc_ai_app_rescue_tagline = /** @type {(inputs: Svc_Ai_App_Rescue_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construiu com Lovable, Bolt ou Cursor e encravou? Reparo e lanço.`)
};

const zh_svc_ai_app_rescue_tagline = /** @type {(inputs: Svc_Ai_App_Rescue_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 Lovable、Bolt 或 Cursor 做到一半卡住了？我来修好并上线。`)
};

const tr_svc_ai_app_rescue_tagline = /** @type {(inputs: Svc_Ai_App_Rescue_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lovable, Bolt ya da Cursor ile yapıp takıldınız mı? Düzeltir, yayına alırım.`)
};

const ru_svc_ai_app_rescue_tagline = /** @type {(inputs: Svc_Ai_App_Rescue_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Застрявшая сборка на Lovable, Bolt или Cursor? Починю и запущу.`)
};

const pl_svc_ai_app_rescue_tagline = /** @type {(inputs: Svc_Ai_App_Rescue_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powstało w Lovable, Bolt albo Cursor i utknęło? Naprawię i wypuszczę to.`)
};

/**
* | output |
* | --- |
* | "Built it with Lovable, Bolt or Cursor and got stuck? I fix and ship it." |
*
* @param {Svc_Ai_App_Rescue_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_tagline = /** @type {((inputs?: Svc_Ai_App_Rescue_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_tagline(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_tagline(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_tagline(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_tagline(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_tagline(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_tagline(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_tagline(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_tagline(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_tagline(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_tagline(inputs)
	return en_svc_ai_app_rescue_tagline(inputs)
});
export { svc_ai_app_rescue_tagline as "svc_ai-app-rescue_tagline" }